import { AxiosInstance, AxiosRequestConfig, Method, AxiosError } from "axios";
import { ErrorResponse } from "@core/types/errorResponse";
import ApiResponse from "@core/types/apiResponse";

export async function sendRequest<TReq, TRes>(
    axios: AxiosInstance,
    method: Method,
    url: string,
    data?: TReq,
    config?: AxiosRequestConfig
  ): Promise<ApiResponse<TRes, ErrorResponse>> {
    try {
      const response = await axios.request<TRes>({
        method,
        url,
        data,
        ...config,
      });
  
      return {
        data: response.data,
        error: null,
        status: response.status,
        isSuccess: () => true,
        isError: () => false,
        getData: () => response.data,
        getError: () => null,
      };
    } catch (error: any) {
      const err = error as AxiosError<ErrorResponse>;
      const body = err.response?.data;
      const httpStatus = err.response?.status ?? 500;
      // The API body carries the status as `status` (RFC 7807), so derive
      // `statusCode` from the real HTTP response so downstream routing works.
      const errData: ErrorResponse = {
        ...(body ?? {}),
        statusCode: httpStatus,
        title: body?.title ?? 'Network Error',
        detail: body?.detail ?? err.message,
      };

      return {
        data: null,
        error: errData,
        status: httpStatus,
        isSuccess: () => false,
        isError: () => true,
        getData: () => null,
        getError: () => errData,
      };
    }
  }